import React, { useEffect } from 'react';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { SubmitButton, SubmitButtonProps } from '../../../../ui';
import { basketSelectors } from '../../../redux';
import { stripeClient } from '../../../services';

interface StripePayButtonProps extends SubmitButtonProps {}

type Props = StripePayButtonProps & MapStateToProps & MapDispatchToProps;
const StripePayButton: React.FC<Props> = (props) => {
  const {
    payment,
    translate,
    stripeUpdatePayload,
    checkoutErrors,
    orderPayload,
    children,
    onClick,
    disabled,
    ...buttonProps
  } = props;

  const status = payment && payment.status;
  const buttonText = payment ? payment.Description : 'Loading';
  const noStripe = !payment;

  useEffect(() => {
    try {
      if (status === 'success') {
        console.log('[STRIPE] UPDATE', stripeUpdatePayload);
        stripeClient.paymentRequest.update(stripeUpdatePayload);
      }
    } catch (error) {}
  }, [stripeUpdatePayload, status]);

  const onSubmit = (e) => {
    if (onClick) {
      onClick(e);
    }
    if (checkoutErrors.length || typeof orderPayload === 'string' || !orderPayload) {
      // there r extra steps (missing name, missing time) so we need to call show() in confirm dialog
      console.log('[STRIPE_PAY_BUTTON] VALIDATION', checkoutErrors);
      return;
    }
    console.log('[STRIPE_PAY_BUTTON] SHOW');

    stripeClient.paymentRequest.show();
  };

  return (
    <SubmitButton {...buttonProps} disabled={disabled || noStripe} onClick={onSubmit}>
      {children || translate(buttonText)}
    </SubmitButton>
  );
};

type MapStateToProps = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: WebOrder.State) => {
  const payment = basketSelectors.getSelectedPayment(state);

  const stripeUpdatePayload = basketSelectors.getStripePaymentRequestUpdateOptions(state);
  const checkoutErrors = basketSelectors.getCheckoutErrors(state);
  const orderPayload = basketSelectors.getOrderPayload(state);

  return {
    payment,
    stripeUpdatePayload,
    checkoutErrors,
    orderPayload,
    translate: getTranslate(state.locale)
  };
};

type MapDispatchToProps = ReturnType<typeof mapDispatchToProps>;
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect<MapStateToProps, MapDispatchToProps, StripePayButtonProps>(
  mapStateToProps,
  mapDispatchToProps
)(StripePayButton);
